import Cursor from './Cursor'

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === 'webcomponent' && payload.type === 'Cursor') {
    return [Cursor]
  }
}